<template>
    <div>
        <div class="modal micromodal-slide" id="contact-modal" aria-hidden="true" v-if="is_admin">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-edit-external-contact-title">
                    <div class="modal__content" id="modal-edit-external-contact-content">
                        <h3>{{ title }}</h3>
                        <div class="form__group">
                            <label class="form__label" for="name">Name</label>
                            <input type="text" id="name" name="name" class="form__control" v-model="externalContact.name">
                        </div>

                        <div v-for="field in listData.fields" class="form">
                            <div class="form__group">
                                <label class="form__label">{{ field.label }}</label>
                                <input v-if="field.type != 'yes_no'" type="text" class="form__control" v-model="externalContact.fields[field.label]">
                                <input v-if="field.type == 'yes_no'" type="checkbox" class="form__control" v-model="externalContact.fields[field.label]">
                            </div>
                        </div>
                    </div>
                    <footer class="modal__footer">
                        <button class="btn btn-danger" v-if="externalContact.id" v-on:click.stop.prevent="confirmDeleteContact()">
                            <i class="icon ion-md-trash"></i>
                        </button>
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-primary" v-on:click.stop.prevent="addEditContact(externalContact.id)">{{ title }}</button>
                    </footer>
                </div>
            </div>
        </div>
        <div class="modal micromodal-slide" id="delete-contact" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                    <div class="modal__content" id="modal-new-category-content">
                        <h3>Delete contact "{{ externalContact.name }}"</h3>
                        <p>Are you sure you wish to delete "{{ externalContact.name }}"?</p>
                    </div>
                    <footer class="modal__footer">
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-danger" v-on:click.stop.prevent="deleteContact(externalContact.id)">Delete</button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';

    export default {
        props: {
            externalContact : {
                default: {
                    name: "",
                    fields: {}
                }
            },
            listData : {
                default: []
            }
        },
        data() {
            return {
                is_admin: window.user_can.admin,
            }
        },
        computed: {
            title: function(){
                if( typeof this.externalContact.id !== "undefined"){
                    return "Edit contact";
                }else{
                    return "Create contact";
                }
            }
        },
        methods: {
            addEditContact(externalContactID){
                if(typeof externalContactID === "undefined"){
                    axios.post('/api/people/contact-list/' + this.listData.id + '/contact', this.externalContact).then((response) => {
                        this.$emit('update-list');
                        MicroModal.close("contact-modal");
                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    axios.put('/api/people/contact-list/' + this.listData.id + '/contact/' + externalContactID, this.externalContact).then((response) => {
                        this.$emit('update-list');
                        //this.getUsers(this.page);
                        MicroModal.close("contact-modal");
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            deleteContact(externalContactID){
                if(typeof externalContactID !== "undefined"){
                    axios.delete('/api/people/contact-list/' + this.listData.id + '/contact/' + externalContactID).then((response) => {
                        MicroModal.close("delete-contact");
                        this.$emit('update-list');
                        //this.$store.dispatch('auth/fetchTeam');
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            confirmDeleteContact(){
                MicroModal.close("contact-modal");
                MicroModal.show("delete-contact");
            }
        }
    }
</script>
